// import Site from 'interfaces/Site';
import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import SGBody from 'components/Typography/SGBody';
import BrandIcons from '../../BrandIcons';
import {Site} from 'hooks/useSiteInfo/interfaces/Site';
import SiteType from 'hooks/useSiteInfo/interfaces/SiteType';

const StyledSearchSuggestionsContainer = styled.div`
  position: relative;
  z-index: 3;
  max-height: 75vh;
  overflow-y: scroll;
  background-color: ${props => props.theme.cardBg};
  display: flex;
  flex-direction: column;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  max-width: 396px;
  box-shadow: 0px 2px 1px -1px rgba(255, 255, 255, 0.2), 0px 1px 1px 0px rgba(255, 255, 255, 0.14),
    0px 1px 3px 0px rgba(255, 255, 255, 0.12);
`;

const StyledSearchSuggestionButton = styled(Button)`
  margin: 0;
  padding: 12px 0px;
  color: ${props => props.theme.text};
  text-align: left;
  border-radius: 0;
  width: 100%;
  text-transform: none;
  justify-content: flex-start;
  &:hover {
    background-color: ${props => props.theme.blue2}54;
  }
  &.disabled {
    opacity: 0.5;
    color: ${props => props.theme.disabledStateText};

    background-color: ${props => props.theme.navyGrey};
    &:hover {
      /* background-color: ${props => props.theme.disabledStateBlue}; */
    }
  }

  .MuiButton-label {
    display: grid;
    font-size: 0.8rem;
    color: ${props => props.theme.subtleText};
    text-decoration: none;
    grid-column-gap: 6px;
    grid-template-areas:
      'icon siteName siteName siteName'
      'icon siteInfo siteInfo siteInfo';
    grid-template-columns: 48px auto auto auto;
    grid-template-rows: auto auto;
    text-align: left;
    transition-duration: 150ms;
  }
`;

const StyledSGSiteName = styled(SGBody)`
  grid-area: siteName;
  word-break: break-all;
  color: ${props => props.theme.text};
  font-weight: 700;
`;

const StyledSGSiteInfo = styled(SGBody)`
  grid-area: siteInfo;
  color: ${props => props.theme.text}80;
`;

interface SearchSuggestionsProps {
  isOpen: boolean;
  suggestedSearchItems: Site[];
  handleSiteSuggestionClick: (site: Site) => void;
  numberOfSitesToDisplay?: number;
}

function SearchSuggestions({
  isOpen,
  suggestedSearchItems,
  handleSiteSuggestionClick,
  numberOfSitesToDisplay = 20,
}: SearchSuggestionsProps) {
  return (
    <StyledSearchSuggestionsContainer>
      {isOpen &&
        suggestedSearchItems.slice(0, numberOfSitesToDisplay).map((site: Site) => {
          const hasNpos = 'hasNpos' in site ? site.hasNpos : false;
          return (
            <StyledSearchSuggestionButton
              key={site.siteId}
              onClick={() => handleSiteSuggestionClick(site)}
              disabled={!hasNpos}
              className={hasNpos ? 'npos' : 'disabled'}
            >
              <BrandIcons siteBrand={site.brand} color="light" />
              <StyledSGSiteName>{`${site.siteCode} ${site.siteName}`}</StyledSGSiteName>
              <StyledSGSiteInfo variant="b4">
                {site.brand} {site.geo}{' '}
                {site.siteType === SiteType.Retail && `${site.storeConcept} ${site.businessStatus}`}{' '}
                {hasNpos && 'NPOS'}
              </StyledSGSiteInfo>
            </StyledSearchSuggestionButton>
          );
        })}
    </StyledSearchSuggestionsContainer>
  );
}

export default SearchSuggestions;
